<template>
    <vTransactionFlowPendingComponent :postList="postList" v-if="flag"></vTransactionFlowPendingComponent>
</template>
<script>
import vTransactionFlowPendingComponent from '../../listComponent/basicdata/transactionFlowPending/transactionFlowPendingComponent.vue';
export default {
    name: 'transactionFlowPending',
    components: {
        vTransactionFlowPendingComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                rel_type: true,
                rel_rid_in_detail: true,
                process_status: true,
                is_negative: true,
                business_rid: true,
                product_rid: true,
                date: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                addBtn: true,
                matchBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>